/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:02 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var LEResourceResolver = require("leResourceResolver");

    //list of keys on the Content JSON instead of repeating strings everywhere
    var KEYS = {
        ID: "id",
        NAME: "name",
        ENABLED: "enabled",   //Whether the item is active or not
        DELETED: "deleted",   //Whether the item is deleted or not
        DATA: "data",
        MSG: "msg",
        TITLE: "title",
        LANG: "lang",
        IS_DEFAULT: "isDefault",    //Flag to state whether the value of msg attribute is default.
        TEMPLATE_ID: "templateId",  //An id number of a template which was used to instantiate the object
        ATTRIBUTES: "attributes",
        ATTR_NAME: "name",
        ATTR_VALUE: "value"

    };
    var ContentSystemBaseModel = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemBaseModel = RevisionedModel.extend({
            langContentIndexMap: {},
            defaults : {
                id: null, //new model id must be null so model.isNew() wil work
                enabled: true,
                data: []
            },

            initialize: function(options){
                RevisionedModel.prototype.initialize.call(this, options);
                this.resetLanguageContentMap();
            },

            publishEnableValidation: {

            },

            validation: {

            },

            /*
             Create a map object to map between language string - and its index on the model language content array
             */
            resetLanguageContentMap: function() {
                var langContentArray = this.getData();
                this.langContentIndexMap = {};
                _.each(langContentArray, function(element, index, list){
                    this.langContentIndexMap[element.lang] = index;
                }, this) ;
            },
            hasContentMessage: function(lang){
                return this.hasLanguage(lang) &&
                    this.getContentMessage(lang).length > 0;
            },

            hasLanguage: function(lang){
                return _.has(this.langContentIndexMap,lang);
            },
            getData: function(){
                return this.get(KEYS.DATA);
            },
            setData: function(data, options){
                options = options || {};
                options.silent = true;

                this.set(KEYS.DATA, data, options);
                this.resetLanguageContentMap();
                this.trigger("change:data change");
            },
            getTemplateId: function(){
                return this.get(KEYS.TEMPLATE_ID);
            },

            //todo implement isRevertSupported by checking if have templateID

            getContentMessage: function(lang){
                if (this.hasLanguage(lang)){
                    var msg = this.get(this.getContentMSGKey(lang));
                    return msg? msg:"";
                }  else {
                    return "";
                }
            },

            setContentMessage: function(lang,message){
                if (!this.hasLanguage(lang)){
                    this._addNewContent(lang);
                }
                this.set(this.getContentMSGKey(lang),message);
                this.set(this._getIsDefaultKey(lang),false); //language content was updated we are not default anymore
            },

            _addNewContent: function(lang){
                this.langContentIndexMap[lang ] = this._getIndexForNewContent();
                this.set(this.getContentKey(lang),{msg: "","lang": lang, "isDefault": false});
            },
            _getIndexForNewContent : function(){
                var data = this.getData();
                //support index 0 and it will be created
                return data ? data.length : 0;
            },
            //return list of all language codes found on the data
            getLanguages: function() {
                var langArray = [];
                var data = this.getData();
                if (data) {
                    langArray = _.map(data,function(obj){
                        return obj[KEYS.LANG];
                    });
                }

                return langArray;
            },
            getEnabledState: function(){
                return this.get(KEYS.ENABLED);
            },
            setEnabledState: function(state){
                this.set(KEYS.ENABLED,state);
            },
            getContentDataKey: function(){
                return KEYS.DATA;
            },
            getContentKey: function(lang){
                return KEYS.DATA+"."+this.langContentIndexMap[lang];
            },
            getContentMSGKey: function(lang){
                return this.getContentKey(lang) +"."+ KEYS.MSG;
            },
            _getIsDefaultKey: function(lang){
                return this.getContentKey(lang) +"."+ KEYS.IS_DEFAULT;
            },

            isEnabledEditable: function(){
                return true;
            },
            getID: function() {
                return this.get(KEYS.ID);
            },
            /**
             * Basic content validation called implicitly by the UI ( not the validate that is called by save )
             * @returns {*}
             */
            validateContent: function() {
                this.cleanData();
                this.setValidations();
                return this.isValidAttr();
            },

            setValidations: function(){
                this.validation = {};
                _.each(this.getValidationConfig().validation, function (val, key) {
                    if (this.checkValidationCondition(key) && (this.has(key) || _.has(this.attributes,key) || _.isNull(this.get(key)))) {
                        this.validation[key] = val;
                    }
                }, this);
                this.setValidationsForArrays(this.getValidationConfig().validationForArrays);
                this.logValidations();
            },
            //todo consult Elina should we move this to baseModel?
            setValidationsForArrays: function (validationForArrays) {
                var flatAttr;
                _.each(validationForArrays, function (array, attr) {

                    if (this.checkValidationCondition(attr)) {

                        _.each(array, function (val, key) {
                            if (_.has(this.attributes,attr)) {
                                for (var i = 0; i < this.attributes[attr].length; i++) {
                                    if (this.checkValidationCondition(key, i)) {
                                        flatAttr = attr + "." + key.replace("{index}", i);
                                        this.validation[flatAttr] = val;
                                    }
                                }
                            }
                        }, this);

                    }
                }, this);
            },
            checkValidationCondition: function (key, index) {
                var condition = this.getValidationConfig().validationConditions[key];
                if (condition) {
                    return (this[condition.modelFunction](index) === condition.value);
                }
                return true;
            },
            logValidations:function(){
                var str="Content Model Validation: (version: "+this.getValidationConfig().version+") \r\n";
                _.each(this.validation,function(val,key){

                    str+=key+"\r\n";
                });
                this.logger.debug(str);
            },
            save: function(attributes, options){
                this.cleanData();
                this.setValidations();
                this.logger.info("Saving Content message","ContentSystemBaseModel:save",this.attributes);
                return RevisionedModel.prototype.save.call(this, attributes, options);
            },
            isValidAttr: function(attributes){
                this.cleanData();
                this.setValidations();
                return RevisionedModel.prototype.isValidAttr.call(this,attributes);
            }
        });
    });

    ContentSystemBaseModel.KEYS = KEYS;

    return ContentSystemBaseModel;
});
